/* eslint-disable @next/next/no-img-element */
import React, { ReactElement } from "react";
import { gray } from "../../theme";
import * as Dialog from "@radix-ui/react-dialog";
import { XClose } from "@untitled-ui/icons-react";
import styles from "./imageOverlayTrigger.module.scss";
import { CloseButton } from "@kunduz/ui-atoms";

export const ImageOverlayTrigger = (props: Props): ReactElement => {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild onClick={props.onClick}>
        {props.triggerNode}
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content}>
          <img
            className={styles.image}
            src={props.mediaFile}
            alt=""
            loading="lazy"
          />
          <Dialog.Close asChild>
            <CloseButton
              size="md"
              color="gray"
              theme="light"
              className={styles.close}
            >
              <XClose color={gray[200]} />
            </CloseButton>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

interface Props {
  triggerNode: JSX.Element;
  mediaFile: string;
  onClick?: () => void;
}
